export const MERGE = 'merge';
export const OVERWRITE = 'overwrite';

export const requiredFields = [
  'address',
  'city',
  'state',
  'zip'
];

export const blacklistedFields = [
  'createdAt',
  'createdBy',
  'databaseId',
  'databaseName',
  'id',
  'lastUpdatedAt',
  'lastUpdatedBy',
  'modelType',
  'ownerType',
  'ownerUrl',
  'thumbnailUrl',
  'url'
];

export function shouldDisplayRow(properties, propertyDefaults, key) {
  if (properties.length === 0 || blacklistedFields.includes(key)) {
    return false;
  }

  const firstProperty = properties[0];
  const value =
    Array.isArray(firstProperty[key])
      ? firstProperty[key].toString()
      : firstProperty[key];

  let retVal = false;
  const defaultVal = propertyDefaults[key];

  properties.map((property, index) => {
    const val = Array.isArray(property[key]) ? property[key].toString() : property[key];
    let isDefault;

    if (!defaultVal) {
      isDefault = [null, '', '--'].includes(val);
    } else {
      isDefault = val === defaultVal;
    }

    if (index > 0 && (value !== val || !isDefault) && value && val) {
      retVal = true;
    }
  });
  return retVal;
}
